import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import UserService from "@/services/UserService"


Vue.config.productionTip = false

Vue.prototype.$userService = new UserService();


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
